// extracted by mini-css-extract-plugin
module.exports = {"mod-robots":"Robots_mod-robots__rqhxY"};